import config from "../../../../../config/config";
import { apiCall } from "../../../../../_services/apiCall";

/** @returns {Promise<Array<{ id: number, name: string, sub_industries: Array<{ id: number, title: string }> }>>} */
export async function fetchSupplierIndustries() {
  const { isSuccess, data } = await apiCall(
    `${config.PRELOGIN_API_URL_COMPANY}suppliers/industries`,
    {},
    {},
    "GET",
    false,
    false
  );
  if (!isSuccess) return [];
  const raw = Array.isArray(data?.data) ? data.data : [];
  return raw.map((group) => ({
    id: group.industry_type_id,
    name: group.industry_type_name,
    sub_industries: Array.isArray(group.items) ? group.items : [],
  }));
}

export function getSubIndustriesForIndustry(industries, industryId) {
  if (!industryId || !Array.isArray(industries)) return [];
  const industry = industries.find((item) => String(item.id) === String(industryId));
  return industry?.sub_industries ?? [];
}

export function resolveIndustryNames(industries, industryId, subIndustryId) {
  const industry = industries.find((item) => String(item.id) === String(industryId));
  const subIndustry = industry?.sub_industries?.find(
    (item) => String(item.id) === String(subIndustryId)
  );
  return {
    industry: industry?.name ?? "",
    sub_industry: subIndustry?.title ?? "",
  };
}
